import React from 'react'

import {isDebug} from './utils'
import {simulateVictory, simulateLoss} from '../game-over/utils'
import Config from './config'

const DebugButtons = () => {
    if (!isDebug) {
        return null
    }

    return (
        <div className="debug-buttons">
            <button
                className="side-menu__button"
                onClick={() => simulateVictory()}
            >
                Simulate Victory
            </button>
            <button
                className="side-menu__button"
                onClick={() => simulateLoss()}
            >
                Simulate Loss
            </button>
            <button
                className="side-menu__button"
                onClick={() => {
                    Object.keys(Config.ships).forEach((key) => {
                        Config.ships[key].destroy()
                    })
                }}
            >
                Destroy Ships
            </button>
        </div>
    )
}

export default DebugButtons
